module.exports = __webpack_public_path__ + "img/Wp_2057.f0934fbd.png";